import { render, staticRenderFns } from "./GradesItem.vue?vue&type=template&id=7fe4bdd0&scoped=true&"
import script from "./GradesItem.vue?vue&type=script&lang=js&"
export * from "./GradesItem.vue?vue&type=script&lang=js&"
import style0 from "./GradesItem.vue?vue&type=style&index=0&id=7fe4bdd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4bdd0",
  null
  
)

export default component.exports